
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M21.5 27a.5.5 0 110 1h-14a.5.5 0 110-1h14zM20.182 7.875l.093.179.155-.018c3.74-.407 6.363 1.058 6.478 4.26l.003.221c0 2.34-1.58 5.475-4.722 9.454l-.189.236V24.5a.5.5 0 01-.41.492L21.5 25H7.502a.5.5 0 01-.5-.484l.006-.09 1.459-9.851-2.9-4.817a.5.5 0 01.341-.75L5.995 9h3.049l.007-.069.024-.087c2.507-6.788 7.854-7.108 11.107-.97zm-9.967.798L10.084 9H13a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.492L13 10H6.879l2.537 4.213a.5.5 0 01.072.245l-.005.086L8.08 24H21v-1.967a.5.5 0 01.063-.242l.047-.07c3.209-3.995 4.801-7.081 4.801-9.204 0-2.763-2.275-3.963-5.849-3.425a.5.5 0 01-.524-.277c-2.76-5.704-7.007-5.756-9.323-.142zm13.73 3.707c.366 1.25-.483 3.201-2.487 5.976a.5.5 0 01-.81-.585c1.824-2.526 2.583-4.27 2.337-5.11-.222-.76-.877-1.034-2.177-.794a.5.5 0 11-.18-.984c1.75-.322 2.928.168 3.317 1.497z"}})])
          )
        }
      }
    